import React, { useEffect, useState } from "react";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import "./ManualOperacoes.css";

const DEFAULT_MANUAL_URL = "https://online.fliphtml5.com/smartolfativos/Manual-Licenciado-2/";

const ManualOperacoes = () => {
  const [menuClose, setMenuClose] = useState(false);
  const [manualUrl, setManualUrl] = useState(DEFAULT_MANUAL_URL);
  const [loading, setLoading] = useState(true);

  const toggleMenu = () => {
    setMenuClose((prev) => !prev);
  };

  useEffect(() => {
    let mounted = true;

    const loadManual = async () => {
      try {
        setLoading(true);
        const response = await Api.get("/public/manual-operations");
        const nextUrl = String(response?.data?.settings?.embedUrl || "").trim();

        if (!mounted) return;
        setManualUrl(nextUrl || DEFAULT_MANUAL_URL);
      } catch (err) {
        console.error("Erro ao carregar manual de operacoes:", err);

        if (!mounted) return;
        setManualUrl(DEFAULT_MANUAL_URL);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadManual();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="app-container">
      <Sidebar close={menuClose} manualOperacoesActive="active" />

      <main className="main-content">
        <Topbar page="Manual de operacoes" onToggleMenu={toggleMenu} />

        <section className="manual-card">
          <div className="manual-card-header">
            <div>
              <h1 className="manual-card-title">Manual de operacoes</h1>
              <p className="manual-card-description">
                Consulte o manual completo do licenciado diretamente no sistema, em formato revista.
              </p>
            </div>
          </div>

          {loading ? (
            <div className="manual-empty-state">Carregando manual de operacoes...</div>
          ) : manualUrl ? (
            <div className="manual-frame-wrapper">
              <iframe
                className="manual-frame"
                src={manualUrl}
                title="Manual de operacoes"
                scrolling="no"
                frameBorder="0"
                allowTransparency
                allowFullScreen
              />
            </div>
          ) : (
            <div className="manual-empty-state">
              Nenhum manual configurado no momento. Procure o super administrador.
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

export default ManualOperacoes;
